import { render, staticRenderFns } from "./currencySelect.vue?vue&type=template&id=d5f5e986&scoped=true&"
import script from "./currencySelect.vue?vue&type=script&lang=js&"
export * from "./currencySelect.vue?vue&type=script&lang=js&"
import style0 from "./currencySelect.vue?vue&type=style&index=0&id=d5f5e986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f5e986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
